// this file is automatically generated by git.revision.js script
export const versions = { revision: 'b9aeffa7fe' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'b9aeffa7fe';
